import * as angular from 'angular';

(function () {
    'use strict';

    angular.module('app').component('imFooter', {
        template: require('/builds/imieszkaniec.pl/iwykonawca/frontend/src/app/components/footer/footer.html'),
        controller: 'FooterController',
        controllerAs: 'FooterCtrl',
        bindings: {
            urlBugReport: '<',
            isFullWidth: '<',
        },
    });
})();



// WEBPACK FOOTER //
// ./node_modules/angularjs-template-loader??ref--0-1!./src/app/components/footer/footer.component.ts